import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { HttpClientRequestService } from 'src/app/http-client-request.service';
import { ConstantsService } from 'src/app/constants.service';
import * as AWS from 'aws-sdk'
 
const emailPattern: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
const numberPattern: RegExp = /^[0-9]*$/;
@Component({
  selector: 'app-hcpsignup',
  templateUrl: './hcpsignup.component.html',
  styleUrls: ['./hcpsignup.component.scss']
})
export class HcpsignupComponent implements OnInit {
  tokenResponse: String = null;
  thankYouDiv: boolean = true;
  hcpsignUpForm: boolean = false;
  AWSSMClient: AWS.SecretsManager;
  AWSSTSClient: AWS.STS;
  AWSS3Client: AWS.S3;
  AWSS3JsonRequest: AWS.S3.Types.PutObjectRequest;
  AWSS3DataMaxBody: any;
  inputBody: any;
  inputExpection: any;
  recaptchabody: any;
  constructor(private _formBuilder: UntypedFormBuilder, private _httpClientRequestService: HttpClientRequestService, private _constantsService: ConstantsService) { }
  signupForm: UntypedFormGroup;
  disableButton: boolean = false;
  ngOnInit() {
    this.signupForm = this._formBuilder.group({
      FRST_NM: ['', Validators.required],
      LAST_NM: ['', Validators.required],
      email: ['', [Validators.required, Validators.pattern(emailPattern)]],
      ZIP5_CD: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(5), Validators.pattern(numberPattern)]],
      NPI: ['', null],
      BUS_NM: ['', null]
    });
  }
  hcpsignup() {
    if (this.signupForm.valid) {
      // Removed captcha
      this.disableButton = true;
      this.inputBody = {
        "email": this.signupForm.get('email').value,
        "workflowId": this._constantsService.iQviaWorkflowID,
        "dataFields": {
          "FRST_NM": this.signupForm.get('FRST_NM').value,
          "LAST_NM": this.signupForm.get('LAST_NM').value,
          "ZIP5_CD": this.signupForm.get('ZIP5_CD').value,
          "BUS_NM": this.signupForm.get('BUS_NM').value,
          "NPI": this.signupForm.get('NPI').value
        }
      }
 
            // AWS
            this.AWSS3DataMaxBody = {
              "email": this.signupForm.get('email').value,
              "firstName": this.signupForm.get('FRST_NM').value,
              "lastName": this.signupForm.get('LAST_NM').value,
              "zip": this.signupForm.get('ZIP5_CD').value,
              "institutionName": this.signupForm.get('BUS_NM').value,
              "npi": this.signupForm.get('NPI').value,
              "specialty": "",
              "cslEmailRep": false,
              "cslEmailAndembryInfo": false
            };
            // AWS - Secrets Manager
            let secretNameKey = 'andembry-hcp-datamax-secret'; // DEV / PROD
            //let secretsManagerUserKey = 'AKIATZ3TLKL2D34LJTOO'; // DEV
            let secretsManagerUserKey = 'AKIAVHD5H4CN62OFKTZO'; // PROD
            //let secretsManagerUserSecret = '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'; // DEV
            let secretsManagerUserSecret = 'L+7DtFx1a4odyN8Sjas0WVm8CNCCCWsNZPQY/UUI'; // PROD
            // AWS - Assume Role User
            //let iamAssumeRoleKey = 'AKIATZ3TLKL2JSZAMQY6'; // DEV
            let iamAssumeRoleKey = 'AKIAVHD5H4CNXZW7F7X6'; // PROD
            //let iamDestinationRoleArn = 'arn:aws:iam::595009892229:role/datamax-comercial-gara-cda-qa-role'; // DEV
            let iamDestinationRoleArn = 'arn:aws:iam::483647236774:role/datamax-comercial-gara-cda-prod-na-role'; // PROD
            //let iamDestinationRoleExternalId = 'c4xwt6zgeM4z'; // DEV
            let iamDestinationRoleExternalId = '4RAcHU6hqn9K'; // PROD
            let iamAssumeRoleSessionName = "s3-access-datamax-gara"; // DEV / PROD

            //Create a SecretsManagerClient
            this.AWSSMClient = new AWS.SecretsManager({
              region: `us-east-1`,
              apiVersion: `latest`,
              credentials:{
                accessKeyId: secretsManagerUserKey,
                secretAccessKey: secretsManagerUserSecret
              }
            });
            const writeToS3 = this.AWSSMClient.getSecretValue({ SecretId: secretNameKey }, (err, data) => {
              if (err) {
                console.log(JSON.stringify(err));
                return 'err';
              } else {
                const secretStringFromSM = JSON.parse(data.SecretString);
                //Create a StsClient
                this.AWSSTSClient = new AWS.STS({
                  region: `us-east-1`,
                  apiVersion: `latest`,
                  credentials:{
                    accessKeyId: iamAssumeRoleKey,
                    secretAccessKey: secretStringFromSM[secretNameKey]
                  }
                });
                //Sts Assume Role
                this.AWSSTSClient.assumeRole({
                  RoleArn: iamDestinationRoleArn,
                  RoleSessionName: iamAssumeRoleSessionName,
                  ExternalId: iamDestinationRoleExternalId
                }, (err, data) => {
                  if (err) {
                    console.log(JSON.stringify(err));
                    return 'err';
                  } else {
                    // AWS S3            
                    this.AWSS3Client = new AWS.S3({ 
                      accessKeyId: data.Credentials.AccessKeyId, 
                      secretAccessKey: data.Credentials.SecretAccessKey, 
                      sessionToken: data.Credentials.SessionToken,
                      region: `us-east-1` });

                    this.AWSS3JsonRequest = {
                      Bucket: `datamax-commercial-csl-prod-na-cda`,
                      Key: `DATAMAX/US/Gara/Inbound/Landing/andembry_${Date.now()}.json`,
                      Body: JSON.stringify(this.AWSS3DataMaxBody),
                      ContentType: `application/json; charset=utf-8`,
                      CacheControl: `max-age=60`
                    };

                    this.AWSS3Client.putObject(this.AWSS3JsonRequest, (err, data) => {
                      if (err) {
                        console.log(JSON.stringify(err));
                        return 'err';
                      } else {
                        return data;
                      }
                    });
                  }
                })
              }
            });
      
            // IQVIA
            this._httpClientRequestService.PostIqvia(this._constantsService.apiHCPURL, this.inputBody).subscribe(Response => {
              if (Response.code == "Success") {
                this.thankYouDiv = !this.thankYouDiv;
                this.hcpsignUpForm = !this.hcpsignUpForm;
              }
              else {
                this.disableButton = false;
              }

            }, error => {
              this.disableButton = false;
              this.inputExpection = {
                "Status": error.status,
                "msg": error.error.msg,
                "code": error.error.code
              }
              // this._httpClientRequestService.Post(this._constantsService.apiHCPExpection,this.inputExpection).subscribe(ExceptionResponse =>{
              // });
            });
    }
    else {
      this.signupForm.markAllAsTouched();
    }
  }
 
  
  scroll(id: string) {
    document.getElementById(id).scrollIntoView({ behavior: 'smooth', block: "start", inline: "nearest" });
  }
}